/* eslint-disable quote-props */
export default {
  ja: {
    Common: {
      '制空権シミュレータ': '制空権シミュレータ',
      'サイト設定': 'サイト設定',
      'マスターデータ読込中': 'マスターデータ読込中',
      'OK': 'OK',
      '実行': '実行',
      '戻る': '戻る',
      'キャンセル': 'キャンセル',
      'リセット': 'リセット',
      '出力': '出力',
      '作成': '作成',
      '更新': '更新',
      '適用': '適用',
      '展開': '展開',
      '閉じる': '閉じる',
      '初期値': '初期値',
      '最大値': '最大値',
      '既定値': '既定値',
      '削除': '削除',
      '編集': '編集',
      '保存': '保存',
      '別名保存': '別名保存',
      '共有': '共有',
      '編成共有': '編成共有',
      '元に戻す': '元に戻す',
      'やり直す': 'やり直す',
      '編成アップロード': '編成アップロード',
      'コピーされました。': 'コピーされました。',
      'コードをコピー': 'コードをコピー',
      '取込': '取込',
      '検索': '検索',
      '件': '件',
      'さらに読み込む': 'さらに読み込む',
      '制空値': '制空値',
      '制空': '制空',
      '基地制空': '基地制空',
      '敵制空値': '敵制空値',
      '防空制空': '防空制空',
      'x機': '{number}機',
      '装備名称': '装備名称',
      '艦娘名': '艦娘名',
      '装備名': '装備名',
      '敵艦名': '敵艦名',
      '図鑑ID': '図鑑ID',
      '耐久': '耐久',
      '火力': '火力',
      '砲戦火力': '砲戦火力',
      '夜戦火力': '夜戦火力',
      '支援火力': '支援火力',
      '雷撃火力': '雷撃火力',
      '雷装': '雷装',
      '爆装': '爆装',
      '装甲': '装甲',
      '対空': '対空',
      '出撃対空': '出撃対空',
      '防空対空': '防空対空',
      '索敵': '索敵',
      '回避': '回避',
      '命中': '命中',
      '支援命中': '支援命中',
      '対潜': '対潜',
      '対爆': '対爆',
      '迎撃': '迎撃',
      '射程': '射程',
      '搭載数': '搭載数',
      '極長+': '極長+',
      '極長': '極長',
      '極+': '極+',
      '極': '極',
      '超長+': '超長+',
      '超長': '超長',
      '長': '長',
      '中': '中',
      '短': '短',
      '半径': '半径',
      'tp': 'TP',
      'TP': 'TP',
      'TP2': 'TP2',
      'コスト': 'コスト',
      '配置コスト': '配置コスト',
      '射撃回避': '射撃回避',
      '回避性能': {
        '超+': '超+',
        '超': '超',
        '強': '強',
        '中': '中',
        '弱': '弱',
        '任意': '任意',
        'なし': '',
        '': '',
      },
      '装甲減少': '装甲補正',
      '命中項': '命中項',
      '回避項': '回避項',
      'CI項': 'CI項',
      '熟練度': '熟練度',
      '改修': '改修',
      '改修値': '改修値',
      '加重対空': '加重対空',
      '艦隊防空': '艦隊防空',
      '艦隊防空値': '艦隊防空値',
      'Lv': 'Lv',
      '改造Lv': '改造Lv',
      '運': '運',
      '速力': '速力',
      '総搭載数': '総搭載数',
      '装備命中': '装備命中',
      '確保': '確保',
      '優勢': '優勢',
      '拮抗': '拮抗',
      '劣勢': '劣勢',
      '喪失': '喪失',
      '不発': '不発',
      '制空権確保': '制空権確保',
      '航空優勢': '航空優勢',
      '航空拮抗': '航空拮抗',
      '航空劣勢': '航空劣勢',
      '制空権喪失': '制空権喪失',
      '陣形': '陣形',
      '単縦陣': '単縦陣',
      '複縦陣': '複縦陣',
      '輪形陣': '輪形陣',
      '梯形陣': '梯形陣',
      '単横陣': '単横陣',
      '警戒陣': '警戒陣',
      '第一警戒': '第一警戒',
      '第二警戒': '第二警戒',
      '第三警戒': '第三警戒',
      '第四警戒': '第四警戒',
      '通常': '通常',
      '連合': '連合',
      '空襲': '空襲',
      '夜戦': '夜戦',
      '重爆': '重爆',
      '航空戦': '航空戦',
      '超重爆': '超重爆',
      '対潜空襲': '対潜空襲',
      '支援': '支援',
      '合計': '合計',
      '平均': '平均',
      '順序入替': '順序入替',
      '入替完了': '入替完了',
      '一括変更': '一括変更',
      '一括設定': '一括設定',
      'スクリーンショットを保存': 'スクリーンショットを保存',
      '最小化': '最小化',
      '探したけど見つからなかったよ': '探したけど見つからなかったよ',
      'もしかして': 'もしかして:',
      '検索条件': '検索条件のせい',
      '既に配備されています。': '既に配備されています。',
      '配備を押せば無視して配備できます。': '配備 を押せば無視して配備できます。',
      '配備': '配備',
      '比較': '比較',
      '適用対象': '適用対象',
      '選択されている航空隊に対し、下記の設定を適用します。': '選択されている航空隊に対し、下記の設定を適用します。',
      '選択されている艦隊の全艦娘に対し、下記の設定を適用します。': '選択されている艦隊の全艦娘に対し、下記の設定を適用します。',
      '戦闘機のみ最大': '戦闘機のみ最大',
      '艦載機搭載数': '艦載機搭載数',
      '本当に削除しますか？': '本当に削除しますか？',
      '装備特効表示': '装備特効表示',
      'なし': 'なし',
      '鎮守府秋刀魚祭り': '鎮守府秋刀魚祭り',
      'ソート': 'ソート',
      '読み': 'あいうえお',
      '昇順': '昇順',
      '降順': '降順',
      '燃料': '燃料',
      '弾薬': '弾薬',
      '燃料+弾薬': '燃料+弾薬',
      '運改修': '運改修',
      '遠征': '遠征',
      '艦隊に艦載機が含まれています。遠征における艦載機の性能に対する補正の計算式が不明なため、遠征のステータス調整に利用する際は十分注意してください。': '艦隊に艦載機が含まれています。遠征時における艦載機補正値の計算式が不明なため、遠征のステータス調整に艦載機を利用する際は十分注意してください。',
      '遠征ステータスチェッカー': '遠征ステータスチェッカー',
      '旗艦Lv': '旗艦Lv',
      '合計Lv': '合計Lv',
      '絞り込み': '絞り込み',
      'その他': 'その他',
      '最終更新日時': '最終更新日時',
      '外部データ': '外部データ',
      '表示ステータス': '表示ステータス',
      '基本装備性能': '基本装備性能',
      '改修ボーナス': '改修効果',
      '実性能': '実性能',
      '航空隊ステータス': '航空隊ステータス',
    },
    Statuses: {
      'actualFire': '火力',
      'dayBattleFirePower': '砲戦火力',
      'actualTorpedo': '雷装',
      'nightBattleFirePower': '夜戦火力',
      'actualBomber': '爆装',
      'antiAir': '対空',
      'actualAntiAir': '出撃対空',
      'actualDefenseAntiAir': '防空対空',
      'actualArmor': '装甲',
      'actualAsw': '対潜',
      'actualAvoid': '回避',
      'actualScout': '索敵',
      'actualAccuracy': '命中',
      'antiBomber': '対爆',
      'antiAirWeight': '加重対空',
      'antiAirBonus': '艦隊防空',
      'radius': '半径',
      'cost': 'コスト',
      'tp': 'TP',
      'tp2': 'TP2',
      'avoidId': '射撃回避',
      'actualRange': '射程',
    },
    Difficulty: {
      '難易度': '難易度',
      '甲': '甲',
      '乙': '乙',
      '丙': '丙',
      '丁': '丁',
    },
    Setting: {
      '言語': '言語',
      '艦娘や装備名は翻訳しない': '艦娘や装備名は翻訳しない',
      'サイトカラーテーマ': 'サイトカラーテーマ',
      '通常': '通常',
      '空色': '空色',
      '桜色': '桜色',
      '翠色': '翠色',
      '暗色': '暗色',
      '深海': '深海',
      '装備表示UI調整': '装備表示UI調整',
      '枠線': '枠線',
      '太枠': '太枠',
      '角丸': '角丸',
      'sample': 'さんぷる',
      '未保存の編成タブを閉じる際の挙動': '未保存の編成タブを閉じる際の挙動',
      '確認ダイアログを表示する': '確認ダイアログを表示する',
      '編成データのオートセーブ': '編成データのオートセーブ',
      'オートセーブを有効にする': 'オートセーブを有効にする',
      '画像保存形式': '画像保存形式',
      'マウスホバー時の詳細情報表示': 'マウスホバー時の詳細情報表示',
      '無効(装備)': '無効 (装備)',
      '無効(艦娘)': '無効 (艦娘)',
      '表示までのディレイ': '表示までのディレイ',
      '制空計算時のシミュレーション回数': '制空計算時のシミュレーション回数',
      '数値が大きいほど計算の精度が上がりますが、': '数値が大きいほど計算の精度が上がりますが、',
      '計算時のパフォーマンスが低下します。': '計算時のパフォーマンスが低下します。',
      '回': '回',
      '装備選択時のデフォルト熟練度': '装備選択時のデフォルト熟練度',
      '一括設定': '一括設定',
      'デッキビルダー形式データ読込設定': 'デッキビルダー形式データ読込設定',
      '全滅率インジケーター表示': '全滅率インジケーター表示',
      '図形で区別': '図形で区別',
      '常に全艦隊データを読み込む': '常に全艦隊データを読み込む',
      '編成データのバックアップ': 'サイトデータのバックアップ',
      '復元': '復元',
      '保存した編成データのバックアップファイルを作成します': '保存した編成データや、登録した艦隊/装備情報を復元するためのバックアップファイルを作成します',
      '復元するバックアップファイルを選択': '復元するバックアップファイルを選択',
      '復元するデータ選択': '復元するデータ選択',
      '編成データ': '編成データ',
      '在籍艦娘データ': '在籍艦娘データ',
      '所持装備データ': '所持装備データ',
      '艦隊URL出力履歴': '艦隊URL出力履歴',
      '装備変更時の比較画面の表示': '装備変更時の比較画面の表示',
    },
    Home: {
      '要望・バグ報告:': '要望・バグ報告:',
      '連絡先:': '連絡先:',
      'カンパ:': 'カンパ:',
      'こちら': 'こちら',
      '制空権シミュレータ': '制空権シミュレータ',
      'デッキビルダー形式データ': 'デッキビルダー形式データ',
      'URL情報より復元された艦娘在籍情報、装備所持情報が適用されています。': 'URL情報より復元された艦娘在籍情報、装備所持情報が適用されています。',
      '自分の登録情報に戻す場合は次のボタンを押下してください。': '自分の登録情報に戻す場合は次のボタンを押下してください。',
      '終了': '終了',
      '作成した日': '現在適用されている艦隊データは、{date}に作成されたデータです。',
      'メインメニュー': 'メインメニュー',
      '本サイトの主要機能です。': '本サイトの主要機能です。',
      '基地航空隊や艦隊、敵艦隊を編成することで、道中を含めた全ての戦闘の制空状態や艦載機の損耗、全滅率などのシミュレーションが可能です。': '基地航空隊や艦隊、敵艦隊を編成することで、道中を含めた全ての戦闘の制空状態や艦載機の損耗、全滅率などのシミュレーションが可能です。',
      '艦娘 / 装備管理': '艦娘 / 装備管理',
      'サブの機能です。': 'サブの機能です。',
      '自分のゲーム内の艦娘、装備情報を登録すると、シミュレータ内で選択できる艦娘や装備に反映され、あの装備持ってた…？と悩む心配がなくなります。': '自分のゲーム内の艦娘、装備情報を登録すると、シミュレータ内で選択できる艦娘や装備に反映され、あの装備持ってた…？と悩む心配がなくなります。',
      'みんなの編成': 'みんなの編成',
      '他の人がアップロードした編成データを閲覧できます。': '他の人がアップロードした編成データを閲覧できます。',
      'おまけ': 'おまけ',
      'おまけのページです': 'おまけのページです。',
      'データ引き継ぎ': 'データ引き継ぎ',
      '本サイトで作成した編成データなどを他の端末やブラウザに引き継げます': '本サイトで作成した編成データや、登録した艦隊/装備情報を他の端末やブラウザに引き継げます。',
      'バックアップファイルを作成する': 'バックアップファイルを作成する',
      'そろそろバックアップしませんか？': 'そろそろバックアップしませんか？',
      '前回の編成データのバックアップからわりと時間が経っています。': '前回の編成データのバックアップからわりと時間が経っています。',
      'なんらかの影響で編成データが消えた時のために、バックアップファイルを作成することをオススメします。': 'なんらかの影響で編成データが消えた時のために、バックアップファイルを作成することをオススメします。',
      'この通知は、最後のバックアップからだいたい1ヵ月くらいに1度表示されます。今回はスキップした場合も、再度1か月後くらいに通知されます。': 'この通知は、最後のバックアップからだいたい1ヵ月くらいに1度表示されます。今回はスキップした場合も、再度1か月後くらいに通知されます。',
      '今すぐバックアップ': '今すぐバックアップ',
      '今回はスキップ': '今回はスキップ',
      '作成されたバックアップファイルを、引き継ぎ先のPCや端末に移動させる': '作成されたバックアップファイルを、引き継ぎ先のPCや端末に移動させる。',
      '引き継ぎ先で制空権シミュレータv2を開き、サイト設定を開く': '引き継ぎ先のPCや端末で制空権シミュレータv2を開き、「サイト設定」を開く。',
      '手順2で移動させてきたバックアップファイルを選択すれば引き継ぎは完了です': '手順2で移動させてきたバックアップファイルを選択すれば引き継ぎは完了です。',
      '旧制空権シミュレータ': '旧制空権シミュレータ',
      'で作成していた編成データや、登録されていた装備、艦娘情報を引き継ぎます。': 'で作成していた編成データや、登録されていた装備、艦娘情報を引き継ぎます。',
      'データ引継ぎ(編成)': 'データ引継ぎ(編成)',
      'データ引継ぎ(装備/艦娘)': 'データ引継ぎ(装備/艦娘)',
      '引き継ぎ対象のデータを格納するフォルダーを作成します。': '引き継ぎ対象のデータを格納するフォルダーを作成します。',
      'フォルダー名を指定し、実行を押すと引き継ぎを開始します。': 'フォルダー名を指定し、実行を押すと引き継ぎを開始します。',
      '既に本サイトで装備 / 艦娘情報が登録されているようです。': '既に本サイトで装備 / 艦娘情報が登録されているようです。',
      '引き継ぎを行うとこれらのデータは上書きされます。': '引き継ぎを行うとこれらのデータは上書きされます。',
      '本当に引き継ぎを行いますか？': '本当に引き継ぎを行いますか？',
      'サイト連携': 'サイト連携',
      'デッキビルダー形式をURLに ?predeck=で埋め込めば編成を読み込めます。': 'デッキビルダー形式をURLに ?predeck=...で埋め込めば編成を読み込めます。',
      'URLが長すぎて上記の方法でエラーが出る場合は、URL fragmentsを利用した受け渡しも可能です。': 'URLが長すぎて上記の方法でエラーが出る場合は、URL fragmentsを利用した受け渡しも可能です。',
      'また、URL fragmentsを利用した形式では艦隊分析コード(艦娘、装備)形式の読み込みも同時に行うことができます。': 'また、URL fragmentsを利用した形式では艦隊分析コード(艦娘、装備)形式の読み込みも同時に行うことができます。',
      'ご支援': 'ご支援',
      '本サイトは無料ですが、それでもご支援いただけるという方向けに支援の手段を用意しました。': '本サイトは無料ですが、それでもご支援いただけるという方向けに支援の手段を用意しました。',
      'いつも本当にありがとうございます。': 'いつも本当にありがとうございます。',
      '匿名でも利用可能な投げ銭サービスです。': '匿名でも利用可能な投げ銭サービスです。',
      'Amazon ほしい物リスト': 'Amazon ほしい物リスト',
      '物資やギフト券といった形であればこちら。': '物資やギフト券といった形であればこちら。',
      '著作権法第32条に基づき画像を引用し、著作権は権利者様へ帰属します。権利者様側からの画像等の削除の依頼や警告には速やかに対処いたします。': '著作権法第32条に基づき画像を引用し、著作権は権利者様へ帰属します。権利者様側からの画像等の削除の依頼や警告には速やかに対処いたします。',
      'また、本サイトの情報、計算結果によって受けた利益・損害その他あらゆる事象については一切の責任を負いません。': 'また、本サイトの情報、計算結果によって受けた利益・損害その他あらゆる事象については一切の責任を負いません。',
      '編成データ名': '編成データ名',
      '補足情報': '補足情報',
      '更新しました。': '更新しました。',
      '艦隊選択': '艦隊選択',
      '常に全艦隊取り込む': '常に全艦隊取り込む',
      '取り込む艦隊を選択し、取り込みボタンを押してください。': '取り込む艦隊を選択し、取り込みボタンを押してください。',
      'チェックすると、次回以降、常に全ての艦隊を取り込むようになります。': 'チェックすると、次回以降、常に全ての艦隊を取り込むようになります。',
      'この設定は、設定からいつでも変更できます。': 'この設定は、設定からいつでも変更できます。',
      '本ブラウザではデータ保存機能が利用できません。': '本ブラウザではデータ保存機能が利用できません。',
      'お使いのブラウザはIndexedDB非対応のようです。': 'お使いのブラウザはIndexedDB非対応のようです。',
      '編成、設定、艦娘/装備を含む全データは本サイトを閉じた時点で削除されます。': '編成、設定、艦娘/装備を含む全データは本サイトを閉じた時点で削除されます。',
      '別のブラウザのご利用をお勧めします。': '別のブラウザのご利用をお勧めします。',
      '旧編成データが見つかりませんでした。': '旧編成データが見つかりませんでした。',
      '所持装備 / 艦娘データが見つかりませんでした。': '所持装備 / 艦娘データが見つかりませんでした。',
      'データを読み込みましたが、引き継ぎ可能な編成データがありませんでした。': 'データを読み込みましたが、引き継ぎ可能な編成データがありませんでした。',
      '所持装備 / 艦娘データの引き継ぎが完了しました。': '所持装備 / 艦娘データの引き継ぎが完了しました。',
      '編成データの引き継ぎが完了しました。': '編成データの引き継ぎが完了しました。',
      'データ引継ぎに失敗しました。': 'データ引継ぎに失敗しました。',
      '新しいフォルダーを作成しました。': '新しいフォルダーを作成しました。',
      '新しい編成を作成しました。': '新しい編成を作成しました。',
      '削除が完了しました。': '削除が完了しました。',
      '編成の読み込みが完了しました。': '編成の読み込みが完了しました。',
      'デッキビルダー形式編成データを読み込みました。': 'デッキビルダー形式編成データを読み込みました。',
      '在籍艦娘データの更新が完了しました。': '在籍艦娘データの更新が完了しました。',
      '所持装備データの更新が完了しました。': '所持装備データの更新が完了しました。',
      'データの読み込みに失敗しました。正しいデータではない可能性があります。': 'データの読み込みに失敗しました。正しいデータではない可能性があります。',
      '保存しました。': '保存しました。',
      '保存に失敗しました。': '保存に失敗しました。',
      '所持情報の読み取りに失敗しました。': '所持情報の読み取りに失敗しました。',
      '他のタブでデータが更新されました': '他のタブでデータが更新されました',
      '別のタブで編成データが保存されたため、このタブの情報が古い可能性があります。': '別のタブで編成データが保存されたため、このタブの情報が古い可能性があります。',
      '最新の状態に合わせるため、ページ再読み込みをしてください。': '最新の状態に合わせるため、ページ再読み込みをするか、このタブは閉じて最新のタブで操作してください。',
      '無視すると、別タブで保存した内容と食い違ってデータがおかしくなることがあります。': '無視すると、別タブで保存した内容と食い違ってデータがおかしくなることがあります。',
      '再読み込み': '再読み込み',
      '無視': '無視',
      '閲覧モードを終了しました。': '閲覧モードを終了しました。',
      '読み込み失敗 -バックアップデータが壊れてるか、なんか違うファイルです。': '読み込み失敗 -バックアップデータが壊れてるか、なんか違うファイルです。',
      'バックアップデータを復元しました。': 'バックアップデータを復元しました。',
      '入力欄を入れ替えました。': '入力欄を入れ替えました。',
      '100 ～ 100000で指定してください。': '100 ～ 100,000で指定してください。',
      '編成名 / 補足情報': '編成名 / 補足情報',
      'トップ画面へ戻る': 'トップ画面へ戻る',
      '艦娘、装備情報が登録されていません。': '艦娘、装備情報が登録されていません。',
      '共有URLを生成しました。': '共有URLを生成しました。',
      '共有URLの生成に失敗しました。': '共有URLの生成に失敗しました。',
      '出力履歴を削除しました。': '出力履歴を削除しました。',
      '計算が完了しました。': '計算が完了しました。(+100,000回)',
      'ドラッグ & ドロップで入力欄を好きな順に並べ替え、入替完了を押してください。': 'ドラッグ & ドロップで入力欄を好きな順に並べ替え、入替完了を押してください。',
      'アップロードが完了しました。': 'アップロードが完了しました。',
      'アップロードに失敗しました。': 'アップロードに失敗しました。',
      '翻訳がまだ不完全な状態です。よろしければ助けていただけると幸いです。': '翻訳がまだ不完全な状態です。よろしければ助けていただけると幸いです。',
      'お題箱': 'お題箱',
      'コピーされました。': 'コピーされました。',
      '更新が完了しました。': '更新が完了しました。',
      '編成を展開しました。': '編成を展開しました。',
      'URL fragmentsよりデータを読み込みました。': 'URL fragmentsよりデータを読み込みました。',
      '更新履歴': '更新履歴',
      '雑です。': '雑です。',
      'サイトが更新されました': 'サイトが更新されました',
      '更新内容は日本語のみの提供です。': '更新内容は日本語のみの提供です。',
      '更新履歴を取得できませんでした。': '更新履歴を取得できませんでした。',
    },
    SaveData: {
      '新しい編成を作成': '新しい編成を作成',
      '新しいフォルダーを作成': '新しいフォルダーを作成',
      'フォルダーを全て開く': 'フォルダーを全て開く',
      'フォルダーを全て閉じる': 'フォルダーを全て閉じる',
      'サイドバー固定': 'サイドバー固定',
      'サイドバー固定解除': 'サイドバー固定解除',
      '複製して開く': '複製して開く',
      '情報を変更': '情報を変更',
      '名前順でソート': '名前順でソート',
      'このフォルダー内の全データ、フォルダーを名前順にソートします。': 'このフォルダー内の全データ、フォルダーを名前順にソートします。',
      '本当にこのフォルダーを削除しますか？': '本当にこのフォルダーを削除しますか？',
      '外部データを全て削除します。よろしいですか？': '外部データを全て削除します。よろしいですか？',
      '本当にこのデータを削除しますか？': '本当にこのデータを削除しますか？',
      'フォルダー内の全データ、フォルダーが削除されます。': 'フォルダー内の全データ、フォルダーが削除されます。',
      'フォルダー名': 'フォルダー名',
      '編成データ名': '編成データ名',
      '補足情報': '補足情報',
      '保存されたデータ': '保存されたデータ',
      '共有URLを生成': '共有URLを生成',
      'Twitterで共有': 'Twitterで共有',
      '作戦室で開く': '作戦室で開く',
      '羅針盤シミュで開く': '羅針盤シミュで開く',
      'デッキビルダーで開く': 'デッキビルダーで開く',
      'URLの発行に失敗しました。': 'URLの発行に失敗しました。',
      '未保存の変更内容がありますが、このまま編成タブを閉じますか？': '未保存の変更内容がありますが、このまま編成タブを閉じますか？',
      '戻って保存するには、サイト上部の保存ボタンを押してください。': '戻って保存するには、サイト上部の保存ボタンを押してください。',
      '変更内容を破棄してタブを閉じる場合は、このままOKボタンを押してください。': '変更内容を破棄してタブを閉じる場合は、このままOKボタンを押してください。',
      '次回以降表示しない': '次回以降表示しない',
      '新規データ': '新規データ',
      '新しいフォルダー': '新しいフォルダー',
      '引き継ぎデータ': '引き継ぎデータ',
      '投稿者': '投稿者',
      '『トップページ > みんなの編成』ページにて公開される編成をアップロードできます。': '『トップページ > みんなの編成』ページにて公開される編成をアップロードできます。',
      '編成のアップロードを行います。よろしいですか？': '編成のアップロードを行います。よろしいですか？',
      '海域、難易度の指定が正しいか、アップロード前に今一度確認してください。': '海域、難易度の指定が正しいか、アップロード前に今一度確認してください。',
      '原則、アップロードした編成をあとから編集・削除することはできません。': '原則、アップロードした編成をあとから編集・削除することはできません。',
      'どうしても削除したい場合、編成名や投稿者、出撃海域、更新日時や編成の特徴など、削除対象が特定できる情報を添えてご連絡ください。': 'どうしても削除したい場合、編成名や投稿者、出撃海域、更新日時や編成の特徴など、削除対象が特定できる情報を添えてご連絡ください。',
    },
    Airbase: {
      '基地航空隊': '基地航空隊',
      '全航空隊': '全航空隊',
      '第x基地航空隊': '第{number}基地航空隊',
      '第x航空隊': '第{number}航空隊',
      '防空計算モード': '防空計算モード',
      '基地派遣先設定': '基地派遣先設定',
      '出撃': '出撃',
      '防空': '防空',
      '待機': '待機',
      '防空時制空値': '防空時制空値',
      '対重爆制空値': '対重爆制空値',
      '対超重爆制空値': '対超重爆制空値',
      '対重爆補正': '対重爆補正',
      '対超重爆補正': '対超重爆補正',
      '補正A': '補正A',
      '補正B': '補正B',
      '補正C': '補正C',
      '補正D1': '補正D1',
      '補正D2': '補正D2',
      '{target}基地航空隊の半径が不足している可能性があります。': '{target}基地航空隊の半径が不足している可能性があります。',
      '{target}基地航空隊の半径が不足しています。': '{target}基地航空隊の半径が不足しています。',
      '第x波': '第{number}波',
      '搭載数を最大に戻す': '搭載数を最大に戻す',
      '基地空襲被害を発生させる': '基地空襲被害を発生させる',
      '第1スロットから順に搭載数を4機減らします。': '第1スロットから順に搭載数を4機減らします。',
      '全基地航空隊リセット': '全基地航空隊リセット',
      '基地航空隊派遣先設定': '基地航空隊派遣先設定',
      '基地航空隊詳細': '基地航空隊詳細',
      '基地空襲が発生します。基地空襲による被害を考慮してください。': '基地空襲が発生します。基地空襲による被害を考慮してください。',
      '基地クリップボード': '基地クリップボード',
      '基地全てクリップボードへ追加': '基地全てクリップボードへ追加',
    },
    Fleet: {
      '自艦隊': '自艦隊',
      '全艦隊': '全艦隊',
      '12隻表示': '12隻表示',
      '第x艦隊': '第{number}艦隊',
      '艦隊追加': '艦隊追加',
      '艦隊削除': '艦隊削除',
      '第x艦隊以降のデータは本サイト内でのみ有効で、外部サイトへの出力の対象になりません。': '第5艦隊以降のデータは本サイト内でのみ有効で、外部サイトへの出力の対象になりません。',
      '画像出力': '画像出力',
      '司令部Lv': '司令部Lv',
      '連合艦隊': '連合艦隊',
      '主力艦隊': '主力艦隊',
      '随伴艦隊': '随伴艦隊',
      '艦隊形式': '艦隊形式',
      '通常艦隊': '通常艦隊',
      '空母機動部隊': '空母機動部隊',
      '水上打撃部隊': '水上打撃部隊',
      '輸送護衛部隊': '輸送護衛部隊',
      '艦娘選択': '艦娘選択',
      '未装備': '未装備',
      '補強増設未開放': '補強増設未開放',
      '艦娘': '艦娘',
      '装備': '装備',
      '装備ボーナス': '装備ボーナス',
      '触接': '触接',
      '夜偵': '夜偵',
      '艦隊詳細': '艦隊詳細',
      '艦隊情報': '艦隊情報',
      '艦隊ステータス': '艦隊ステータス',
      '対空砲火': '対空砲火',
      '航空戦火力': '航空戦火力',
      '夜間航空攻撃': '夜間航空攻撃',
      '対潜支援火力': '対潜支援火力',
      '航空支援火力': '航空支援火力',
      '撃墜': '撃墜',
      '噴進': '噴進',
      '先制対潜': '先制対潜',
      '対潜先制爆雷攻撃': '対潜先制爆雷攻撃',
      '可': '可',
      '不可': '不可',
      '不足対潜値': '不足対潜値',
      '必要艦娘Lv': '必要艦娘Lv',
      'x列': '{number}列',
      '特殊攻撃': '特殊攻撃',
      '一撃大破': '一撃大破',
      '一撃中破': '一撃中破',
      '主主CI': '主主CI',
      '連撃': '連撃',
      '主徹CI': '主徹CI',
      '主電CI': '主電CI',
      '主副CI': '主副CI',
      'FBA': 'FBA',
      'BBA': 'BBA',
      'BA': 'BA',
      'jFjBjB': 'jFjBjB',
      'jFjB': 'jFjB',
      'jFBA': 'jFBA',
      '夜間特殊攻撃': '夜間特殊攻撃',
      '通常': '通常',
      '主主主CI': '主主主CI',
      '主主副CI': '主主副CI',
      '魚雷CI': '魚雷CI',
      '砲雷CI': '砲雷CI',
      '主魚電CI': '主魚電CI',
      '魚見電CI': '魚見電CI',
      '魚水魚CI': '魚水魚CI',
      '魚ド水CI': '魚ド水CI',
      '潜電魚CI': '潜電魚CI',
      '潜魚雷CI': '魚雷CI(潜)',
      '夜襲CIA': '夜襲CI (x1.25)',
      '夜襲CIB': '夜襲CI (x1.20)',
      '光電管彗星CI': '光電管彗星CI',
      '夜爆CI': '夜爆CI (x1.20)',
      '夜襲CIC': '夜襲CI (x1.18)',
      '合計': '合計',
      '搭載数': '搭載数',
      '最終戦闘までの撃墜数に応じて、搭載数を自動設定します。': '最終戦闘までの撃墜数に応じて、搭載数を自動設定します。',
      '満タン': '満タン',
      '最小': '最小',
      '平均': '平均',
      '最大': '最大',
      '戦闘機スロットを最適化': '戦闘機スロットを最適化',
      '全艦隊リセット': '全艦隊リセット',
      '艦隊リセット': '艦隊リセット',
      '艦娘入力欄を増やす': '艦娘入力欄を増やす',
      '艦娘入力欄を減らす': '艦娘入力欄を減らす',
      'ステータス': 'ステータス',
      '改造状態': '改造状態',
      '未改造': '未改造',
      '中間改造': '中間改造',
      '最終改造': '最終改造',
      '装備搭載可否': '装備搭載可否',
      '戦闘機': '戦闘機',
      '甲標的': '甲標的',
      '大型探照灯': '大型探照灯',
      '護衛空母': '護衛空母',
      '装備スロット数': '装備スロット数',
      '2スロ以上': '2スロ以上',
      '3スロ以上': '3スロ以上',
      '4スロ以上': '4スロ以上',
      '5スロ以上': '5スロ以上',
      '最速': '最速',
      '高速+': '高速+',
      '高速': '高速',
      '低速': '低速',
      '低速統一': '低速統一',
      '艦隊': '艦隊',
      '札あり': '札あり',
      '補強増設': '補強増設',
      '開放': '開放',
      '13号電探系': '13号電探',
      '22号電探系': '22号電探',
      '電探マスト': '電探マスト',
      'その他電探': 'その他電探',
      '在籍艦娘反映': '在籍艦娘反映',
      '自動先制対潜': '自動先制対潜',
      'お気に入り': 'お気に入り',
      'お気に入り編集': 'お気に入り編集',
      'ケッコン艦': 'ケッコン艦',
      '全解除': '全てのお気に入り艦娘を解除',
      '搭載': '搭載',
      'コンバート改造': 'コンバート改造',
      '艦娘クリップボード': '艦娘クリップボード',
      '艦隊クリップボード': '艦隊クリップボード',
      '現在の艦隊': '現在の艦隊',
      'デッキビルダー読込': 'デッキビルダー読込',
      '艦隊クリップボードにデッキビルダー形式の艦隊データを直接追加することができます。': '艦隊クリップボードにデッキビルダー形式の艦隊データを直接追加することができます。',
      '装備プリセット展開': '装備プリセット展開',
      '計算対象から省く': '計算対象から省く',
      '装備一括解除': '装備一括解除',
      '対空CI': '対空CI',
      '攻撃機搭載数': '攻撃機搭載数',
      '対空射撃回避': '対空射撃回避',
      '加重対空補正': '加重対空補正',
      '艦隊防空補正': '艦隊防空補正',
      '割合撃墜': '割合撃墜',
      '固定撃墜': '固定撃墜',
      '最低保証': '最低保証',
      '両成功': '両成功',
      '空襲マス': '空襲マス',
      '敵側式': '敵側式',
      'クリップボード': 'クリップボード',
      'クリックで展開': 'クリックで展開',
      'クリップボードへ追加': 'クリップボードへ追加',
      '艦隊に艦娘が設定されていません。': '艦隊に艦娘が設定されていません。',
      '索敵値が不足している可能性があります。': '索敵値が不足している可能性があります。必要索敵値: {LoS}, 分岐点係数: {num}',
      '航空偵察': '航空偵察スコア: {score}、必要: {required}、大成功: {success}',
      'この艦隊に属する全ての艦娘が対象です。': 'この艦隊に属する全ての艦娘に適用されます。',
      '既に札がついている艦娘も上書きする': '既に札がついている艦娘も上書きする',
      '現在の登録情報に置き換え': '現在登録されている艦娘、装備管理の情報に置き換える',
      '存在しない艦娘、装備の置換方法を選択してください。': '存在しない艦娘、装備がある場合の置換方法を選択してください。',
      'この機能を使う場合は、まず艦隊反映を行ってください。': 'この機能を使う場合は、まず艦隊反映を行ってください。',
      '配備されているすべての艦娘と装備を、': '配備されているすべての艦娘と装備を、',
      'で登録されている在籍、所持情報をもとに、なるべくいい感じになるように置き換えます。': 'で登録されている在籍、所持情報をもとに、なるべくいい感じになるように置き換えます。',
      'はずす': 'はずす',
      'そのままにする': 'そのままにする (存在しないと赤字で表示されます)',
      '必要': '{name}が{x}隻必要です。',
      '以下': '{name}は{x}隻までです。',
      '編成不可': '{name}は編成できません。',
      '旗艦': '{name}を旗艦にしてください。',
      '旗艦不可': '{name}は旗艦に編成できません。',
      '高速化': '{name}は速力を向上させてください。',
      '潜水艦隊攻撃配置警告': '潜水艦隊攻撃の発動には、2・3番艦が潜水艦である必要があります。',
      '潜水艦隊攻撃4隻配置警告': '潜水艦隊攻撃(4隻)の発動には、2・3・4番艦が潜水艦である必要があります。',
      '戦艦特殊砲撃水上艦不足警告': '戦艦による特殊砲撃の発動には、同一艦隊に水上艦6隻以上の編成が必要です。',
      '装備置き場生成': '装備置き場生成',
      '装備を自由に置くスペースです。': '装備を自由に置くスペースです。',
      '一括編成': '一括編成',
      '選択済': '選択済',
      '実装': '実装',
      '第1期': '第1期',
      '第2期': '第2期',
    },
    Enemies: {
      '海域': '海域',
      '海域名': '海域名',
      '敵艦隊': '敵艦隊',
      '海域から一括入力': '海域から一括入力',
      '戦闘回数が変更されている可能性があります。派遣先を確認してください。': '戦闘回数が変更されている可能性があります。派遣先を確認してください。',
      '戦闘回数': '戦闘回数',
      '航路': '航路',
      'x戦目': '{number}戦目',
      '搭載数が未確定の敵艦が含まれています。': '搭載数が未確定の敵艦が含まれています。',
      '表示制空値は目安のもので、正確な制空値ではありません。': '表示制空値は目安のもので、正確な制空値ではありません。',
      '海域選択': '海域選択',
      '敵艦選択': '敵艦選択',
      'セル': 'マス',
      '戦闘形式': '戦闘形式',
      '陣形': '陣形',
      '詳細': '詳細',
      '展開したい海域、セル、敵編成を選択してください。': '展開したい海域、マス、敵編成を選択してください。',
      '選択したセル': '選択したマス',
      '前哨': '前哨',
      '最終': '最終',
      'クリア後': 'クリア後',
      '地上施設': '地上施設',
      '変更する': '変更する',
      'はずす': 'はずす',
      '詳細設定': '詳細設定',
      '基地航空隊フェーズで撃沈しない': '基地航空隊フェーズで撃沈しない',
      '基地航空隊フェーズで撃沈する': '基地航空隊フェーズで撃沈する',
      '耐久装甲表示': '耐久装甲表示',
      '本当に戦闘は1戦だけですか？意図せずこのエラーが出ている場合は、経由する道中の敵編成を全て入力してください。': '本当に戦闘は1戦だけですか？意図せずこの表示が出ている場合は、経由する道中の敵編成を全て入力してください。',
    },
    Result: {
      '計算結果': '計算結果',
      '計算結果が実際の制空状態と異なる可能性があります。': '計算結果が実際の制空状態と異なる可能性があります。',
      '戦闘開始時の搭載数推移': '戦闘開始時の搭載数推移',
      '行クリックで詳細計算画面展開': '行クリックで詳細計算画面展開',
      '出撃x回分の計算結果が表示されています。': '出撃{number}回分の計算結果が表示されています。',
      '再計算': '再計算',
      '再計算して精度を上げる': '再計算して精度を上げる',
      '出撃後': '出撃後',
      '全滅率': '全滅率',
      '制空': '制空',
      '制空状態': '制空状態',
      '消費予測': '消費予測',
      '各フェーズ制空状態の確率': '各フェーズ制空状態の確率',
      '基地x y波目': '基地{number} {wave}波目',
      '本隊': '本隊',
      '敵機残数': '敵機残数',
      'このマスで選択する味方艦隊の陣形': 'このマスで選択する味方艦隊の陣形',
      '敵艦': '敵艦',
      '初期搭載': '初期搭載',
      '残数平均': '残数平均',
      '棒立ち率': '棒立ち率',
      '詳細': '詳細',
      '支援艦隊': '支援艦隊',
      '艦隊': '艦隊',
      '種別': '種別',
      '制空値は航空支援専用の制空値です。熟練度や改修値に影響されません。': '制空値は航空支援専用の制空値です。熟練度や改修値に影響されません。',
      '敵制空値は本隊航空戦終了時点での制空値の平均です。': '敵制空値は本隊航空戦終了時点での制空値の平均です。',
      '詳細計算': '詳細計算',
      '支援射撃': '支援射撃',
      '航空支援': '航空支援',
      '対潜支援哨戒': '対潜支援哨戒',
      '対潜支援制空': '対潜支援制空',
      '支援長距離雷撃': '支援長距離雷撃',
      '支援不可(要駆逐2)': '支援不可(要駆逐2)',
      '支援不可(攻撃機なし)': '支援不可(攻撃機なし)',
      '不発': '不発',
      '合計触接率': '合計触接率',
      '対敵通常艦隊': '対敵通常艦隊',
      '対敵連合艦隊': '対敵連合艦隊',
      '触接開始率': '触接開始率',
      '触接率': '触接率',
      'x12触接': '×1.2触接',
      'x117触接': '×1.17触接',
      'x112触接': '×1.12触接',
      '触接不発': '触接不発',
      '攻撃機選択': '攻撃機選択',
      '搭載数': '搭載数',
      'クリティカル': 'クリティカル',
      '姫級表示': '姫級表示',
      '対潜火力(確率)': '対潜火力(確率)',
      '航空支援火力': '航空支援火力',
      '倍率x': '倍率 x{number}',
      '対潜支援火力計算機で確認してください': '対潜支援火力計算タブで確認してください',
      '雷装補正': '雷装補正',
      '種別倍率': '種別倍率',
      'CI倍率': 'CI倍率',
      '種別倍率(最小)': '種別倍率(最小)',
      '改修強化値': '改修強化値',
      '装備シナジーボーナス': '装備シナジーボーナス',
      '熟練甲板要員ボーナス': '熟練甲板要員ボーナス',
      '実雷装値': '実雷装値',
      '実爆装値': '実爆装値',
      '実対潜値': '実対潜値',
      '航空戦定数': '航空戦定数',
      '基本攻撃力': '基本攻撃力',
      'キャップ前攻撃力': 'キャップ前攻撃力',
      'キャップ後攻撃力': 'キャップ後攻撃力',
      'B-25補正': 'B-25補正',
      '基地航空隊補正': '基地航空隊補正',
      '触接補正': '触接補正',
      '陸攻補正': '陸攻補正',
      '陸偵補正': '陸偵補正',
      '敵連合補正': '敵連合補正',
      '特殊敵補正': '特殊敵補正',
      '最終攻撃力': '最終攻撃力',
      '最終攻撃力(最小)': '最終攻撃力(最小)',
      '弾薬補正値': '弾薬補正',
      'ダメージ幅': 'ダメージ幅',
      '撃沈率': '撃沈率',
      '大破率': '大破率',
      '中破率': '中破率',
      '確殺': '確殺',
      '残機数詳細': '残機数詳細',
      '火力計算': '火力計算',
      '残機数分布': '残機数分布',
      '確率分布': '確率分布 [%]',
      '累積確率': '累積確率 [%]',
      '残機数': '残機数',
      '残機数分布をコピー': '残機数分布をコピー',
      '航空戦火力計算機': '航空戦火力計算機',
      '残機数分布を利用': '残機数分布を利用',
      '対空砲火により撃墜される機数の確率分布を利用して計算します。': '対空砲火により撃墜される機数の確率分布を利用して計算します。',
      '搭載数を固定してダメージを確認したい場合はチェックを外してください。': '搭載数を固定してダメージを確認したい場合はチェックを外してください。',
      '残弾薬': '残弾薬',
      '燃料補正': '燃料補正',
      '残弾薬補正': '弾薬補正',
      '回避項x': '回避項 -{value}',
      '特効': '特効',
      'キャップ後火力に適用される倍率です。': 'キャップ後火力に適用される倍率です。',
      'をクリックすると特効値をリセットします。': 'をクリックすると特効値をリセットします。',
      'クリティカル発生時のダメージを表示します。': 'クリティカル発生時のダメージを表示します。',
      'クリティカル補正': 'クリティカル補正',
      '熟練度クリティカル補正': '熟練度クリティカル補正',
      '連合': '連合',
      '防御側が連合艦隊であるかどうかを設定します。': '防御側が連合艦隊であるかどうかを設定します。',
      'ダメージ計算結果': 'ダメージ計算結果',
      '防御艦隊': '防御艦隊',
      'x戦目': '{number}戦目',
      '対潜攻撃不可': '対潜攻撃不可',
      '割合ダメージ': '割合',
      '-': '-',
      '二式陸偵': '二式陸偵',
      '二式陸偵(熟練)': '二式陸偵(熟練)',
      '素火力': '素火力',
      '夜襲CI': '夜襲CI',
      '対空CI一覧': '対空CI一覧',
      '種別id': '種別',
      '固定': '固定',
      '変動': '変動',
      '発動率': '発動率',
      '合計発動率': '合計発動率',
      '基地': '基地',
    },
    EnemyEdit: {
      '敵艦編集': '敵艦編集',
      '本機能は計算結果に大きな影響を及ぼすため、理解できる方のみ利用してください。': '本機能は計算結果に大きな影響を及ぼすため、理解できる方のみ利用してください。',
      '指定した敵艦の装備や搭載数を自由に変更できます。': '指定した敵艦の装備や搭載数を自由に変更できます。',
      '設定内容はお使いのブラウザでのみ有効で、各種共有機能等による共有は行いません。': '設定内容はお使いのブラウザでのみ有効で、各種共有機能等による共有は行いません。',
      '編集する敵艦を選択': '編集する敵艦を選択',
      '変更済み敵艦一覧': '変更済み敵艦一覧',
      '装備、搭載数を設定してください。': '装備、搭載数を設定してください。',
    },
    ItemList: {
      '図鑑id 名称検索': '図鑑id 名称検索',
      '敵装備': '敵装備',
      '対地攻撃': '対地攻撃',
      '夜間機': '夜間機',
      '射撃回避': '射撃回避',
      '特効装備': '特効装備',
      '一列': '一列',
      '複数列': '複数列',
      '以上': '以上',
      '以下': '以下',
      '所持装備反映': '所持装備反映',
      '改修値無効': '改修値無効',
      '装備シナジー無効': '装備シナジー無効',
      '熟練度成長': '熟練度成長',
      '戦': '戦',
      '装備プリセット': '装備プリセット',
      '現在の装備構成で新規登録': '現在の装備構成で新規登録',
      '現在の装備構成で上書き': '現在の装備構成で上書き',
      '名称': '名称',
      '補強増設': '補強増設',
      '固有プリセット': '固有プリセット',
      'プリセット': 'プリセット',
      '保存しました。': '保存しました。',
      '削除しました。': '削除しました。',
      '在庫がなくても展開': '在庫がなくても展開',
      'x機': '{number}機',
      'ブラックリスト': 'ブラックリスト',
      'ブラックリスト登録済み装備': 'ブラックリスト登録済み装備のみ',
      'ブラックリストに登録された装備は、装備一覧画面にて表示されなくなります。': 'ブラックリストに登録された装備は装備一覧画面で表示されなくなります。',
      '全解除': '全ての装備のブラックリスト状態を解除',
      '射程増加': '射程増加',
      '改修値変更': '改修値変更',
      '装備名コピー': '装備名コピー',
      'wikiを開く': 'wikiを開く',
      'メニューを閉じる': 'メニューを閉じる',
      '装備比較': '装備比較',
      '装備シナジー確認': '装備シナジー確認',
      '装備選択時は常に表示する': '装備選択時は常に表示する',
      '一括配備': '一括配備',
      '選択済': '選択済',
      '補': '補',
      'この装備を搭載している艦': 'この装備を搭載している艦',
    },
    Database: {
      '在籍艦娘 / 所持装備データ読込中': '在籍艦娘 / 所持装備データ読込中',
      '反映': '反映',
      '反映(改)': '反映(改)',
      '一覧': '一覧',
      '札管理': '札管理',
      '比較': '比較',
      '経験値': '経験値',
      '分析': '分析',
      'ステータス上昇': 'ステータス上昇',
      '基本条件': '基本条件',
      '名称検索': '名称検索',
      '空白区切りで複数指定可': '空白区切りOK (例:春雨 大鯨)',
      'ネタバレ防止': 'ネタバレ防止',
      '未着任艦非表示': '未着任艦非表示',
      '未着任艦のみ': '未着任艦のみ',
      '補強増設開放済': '補強増設開放済',
      '海色リボン': '海色リボン',
      '白たすき': '白たすき',
      'Lv上限': 'Lv上限',
      'Lv下限': 'Lv下限',
      '取込Lv下限': '取込Lv下限',
      '運上限': '運上限',
      '運下限': '運下限',
      '対潜上限': '対潜上限',
      '対潜下限': '対潜下限',
      '索敵上限': '索敵上限',
      '索敵下限': '索敵下限',
      '回避上限': '回避上限',
      '回避下限': '回避下限',
      '命中項上限': '命中項上限',
      '命中項下限': '命中項下限',
      'CI項上限': 'CI項上限',
      'CI項下限': 'CI項下限',
      '耐久上限': '耐久上限',
      '耐久下限': '耐久下限',
      '火力上限': '火力上限',
      '火力下限': '火力下限',
      '雷装上限': '雷装上限',
      '雷装下限': '雷装下限',
      '夜戦火力上限': '夜戦火力上限',
      '夜戦火力下限': '夜戦火力下限',
      '耐久改修': '耐久改修',
      '耐久改修2': '耐久改修',
      '対潜改修': '対潜改修',
      '対潜改修上限': '対潜改修上限',
      '対潜改修下限': '対潜改修下限',
      '運改修': '運改修',
      '運改修上限': '運改修上限',
      '運改修下限': '運改修下限',
      '艦種': '艦種',
      '国籍': '国籍',
      '日本': '日本',
      'アメリカ': 'アメリカ',
      'イタリア': 'イタリア',
      'イギリス': 'イギリス',
      'ドイツ': 'ドイツ',
      'フランス': 'フランス',
      'ソ連': 'ソ連',
      'その他': 'その他',
      'お札': 'お札',
      '札なし': '札なし',
      '一括チェック': '一括チェック',
      '全選択': '全選択',
      '一覧表示': '一覧表示',
      '艦隊分析表示': '艦隊分析表示',
      '未着任': '未着任',
      '在籍': '在籍',
      '新規登録': '新規登録',
      '練度(Lv)': 'Lv',
      '着任': '着任',
      '除籍': '除籍',
      '本当に除籍しますか？': '本当に除籍しますか？',
      'やっぱやめとく': 'やっぱやめとく',
      '集計対象Lv': '集計対象Lv',
      '合計艦娘数': '合計艦娘数[隻]',
      'ケッコン艦': 'ケッコン艦[隻]',
      '運改修合計': '運改修合計',
      'まるゆ指数': 'まるゆ指数',
      'まるゆを近代化改修に使えば使うほど上昇します。': 'まるゆを近代化改修に使えば使うほど上昇します。',
      'ケッコン以外の手段で運改修を進めていると上昇する指標です。': 'ケッコン以外の手段で運改修を進めていると上昇する指標です。',
      '耐久改修合計': '耐久改修合計',
      '対潜改修合計': '対潜改修合計',
      '補強増設艦': '補強増設艦[隻]',
      '改装設計図必要数': '改装設計図必要数',
      '戦闘詳報必要数': '戦闘詳報必要数',
      'カタパルト必要数': 'カタパルト必要数',
      '改装設計図消費数': '改装設計図消費数',
      '戦闘詳報消費数': '戦闘詳報消費数',
      'カタパルト消費数': 'カタパルト消費数',
      '改装設計図': '改装設計図',
      '戦闘詳報': '戦闘詳報',
      'カタパルト': 'カタパルト',
      '残exp': '残exp',
      '全て展開': '全て展開',
      '全て折りたたむ': '全て折りたたむ',
      '隻数': '隻数',
      '最大Lv': '最大Lv',
      '最小Lv': '最小Lv',
      '中央Lv': '中央Lv',
      '平均Lv': '平均Lv',
      '総経験値': '総経験値',
      '1隻平均': '1隻平均',
      '経験値割合': '経験値割合',
      '艦種別Lv帯分析': '艦種別Lv帯分析',
      'Lv帯別艦娘数': 'Lv帯別艦娘数',
      '艦娘数': '艦娘数 [隻]',
      '艦娘別経験値ランキング': '艦娘別経験値ランキング',
      '登録艦隊': '登録艦隊',
      '現在閲覧中の艦隊': '現在閲覧中の艦隊',
      '差': '差',
      'お札一括更新': 'お札一括更新',
      'お札一斉解除': 'お札一斉解除',
      '解除': '解除',
      '札を解除します。よろしいですか？': '札を解除します。よろしいですか？',
      '解散': '解散',
      '解散します。よろしいですか？': '解散します。よろしいですか？',
      '未所持装備非表示': '未所持装備非表示',
      '改修下限': '改修下限',
      '改修上限': '改修上限',
      'カテゴリ': 'カテゴリ',
      '総所持数表示': '総所持数表示',
      '図鑑ID': '図鑑ID',
      '所持数': '所持数',
      '破棄': '破棄',
      '全破棄': '全破棄',
      '計算したい項目': '計算したい項目',
      '選択した項目と、次にその項目が1繰り上がるのは何Lvであるかを表示します。': '選択した項目と、次にその項目が繰り上がるのは何Lvであるかを表示します。',
      '成長限界に到達した艦娘を省略': '成長限界に到達した艦娘を省略',
      '任意': '任意',
      '任意表示列': '任意表示列',
      '必要経験値表示': '必要経験値表示',
      '運改修モード': '運改修モード',
      'Lvはそのままに、運の改修によってステータスを上昇させようとした場合の結果を計算します。': 'Lvはそのままに、運の改修によってステータスを上昇させようとした場合の結果を計算します。',
      '反映エリア': '反映エリア',
      '共有URL発行機能': '共有URL発行機能',
      '共有URL作成': '共有URL作成',
      '反映後に利用できます': '反映後に利用できます',
      'URL発行': 'URL発行',
      '自分の艦隊、装備情報を他の人に見てもらうためのURLを発行します。': '自分の艦隊、装備情報を他の人に見てもらうためのURLを発行します。',
      '発行された情報は閲覧専用です。発行されたURLを他人に公開しても、自分の艦娘や装備情報が書き換えられてしまうことはありません。': '発行された情報は閲覧専用です。発行されたURLを他人に公開しても、自分の艦娘や装備情報が書き換えられてしまうことはありません。',
      '閲覧する側は、共有された艦娘や装備情報を元に編成を作成することができます。': '閲覧する側は、共有された艦娘や装備情報を元に編成を作成することができます。',
      'URL発行履歴': 'URL発行履歴',
      '発行日': '発行日',
      '展開': '展開',
      '他サイト連携': '他サイト連携',
      '艦隊分析コード': '艦隊分析コード',
      '艦隊分析コードが出力されています。この文字列を別の端末で反映することで、艦隊情報を復元することができます。': '艦隊分析コードが出力されています。この文字列を別の端末に反映することで、艦隊情報を復元することができます。',
      '艦隊コード': '艦隊コード',
      '装備コード': '装備コード',
      '艦隊晒しページ(仮)で展開する場合はこちらから': '艦隊晒しページ(仮)で展開する場合はこちらから',
      '反映手順を表示': '反映手順を表示',
      '反映手順を隠す': '反映手順を隠す',
      '手順1': 'ログイン後、ゲームスタート画面上で右クリックし、コンテキストメニューから「検証」または「開発者ツールで調査する」を選択する。',
      '手順2': '「ネットワーク」タブを開き、赤枠の部分を確認したのち、ゲームスタートを押す。',
      '手順3': '母港画面が表示されたら、「port」という項目が表示されるので、右クリック→「コピー」→「応答のコピー」をクリックする。',
      '手順4': '下記の反映エリアに貼り付けて「反映」を押下する。',
      '手順5': '装備の反映を行います。「require_info」という項目が表示されているので、右クリック→「コピー」→「応答のコピー」をクリックする。',
      '下記はGoogle Chromeの場合です。': '下記はGoogle Chromeの場合です。',
      '注意事項': '絶対にダブルクリックや、「新しいタブで開く」「再送信」などは行わないこと。',
      'ブラウザによって一部表記が変わります。': 'ブラウザによって一部表記が変わります。',
      '未ロックの艦娘も含める': '未ロックの艦娘も含める',
      'ロック済みの艦娘のみ': 'ロック済みの艦娘のみ',
      '未ロックの装備も含める': '未ロックの装備も含める',
      'ロック済みの装備のみ': 'ロック済みの装備のみ',
      '札上書き注意': '現在登録されている艦隊と、取り込もうとした艦隊のお札のデータが一致していません。',
      'このまま取り込むと': 'このまま取り込むと、現在登録されているお札データが上書きされる可能性があります。',
      '札データを上書きして取り込む': '札データを上書きして取り込む',
      '札データを上書きせず取り込む': '札データを上書きせず取り込む',
      '成長の記録': '成長の記録',
      '表示': '表示',
      '新規': '着任',
      '更新': '更新',
      '経験値表示モード': '経験値表示モード',
      '着任しました。': '着任しました。',
      '除籍されました。': '除籍されました。',
      'xから改造されました。': '{base}から改造されました。',
      '補強増設を使用しました。': '補強増設を使用しました。',
      '上限Lvに達しました。': '上限Lvに達しました。',
      'ケッコンカッコカリしました。': 'ケッコンカッコカリしました。',
      'おめでとうございます！': 'おめでとうございます！',
      'Lv99までの折り返し地点を超えました。': 'Lv99までの折り返し地点を超えました。',
      'LvoldからLvcurrentまでの折り返し地点を超えました。': 'Lv{old} から Lv{current} までの折り返し地点を超えました。',
      '後半戦もガンバレ！！！！': '後半戦もガンバレ！！！！',
      'Lvが上昇しました。': 'Lvが上昇しました。',
      '第xスロットの搭載数をy機拡張しました！': '第{slot}スロットの搭載数を{count}機拡張しました！',
      'xしました。': '{x}しました。',
      '増加経験値合計': '増加経験値合計 ',
      '統計': '統計',
      'さらに見る': 'さらに見る',
      '在籍率': '在籍率',
      '総在籍数': '総在籍数',
      '平均在籍数': '平均在籍数',
      '最多在籍数': '最多在籍数',
      '最多EXP': '最多EXP',
      'ケッコン率': 'ケッコン率',
      '補強増設開放率': '補強増設開放率',
      '補強増設開放数': '補強増設開放数',
      '海色リボン付与数': '海色リボン付与数',
      '白たすき付与数': '白たすき付与数',
      '総運改修値': '総運改修値',
      '総耐久改修値': '総耐久改修値',
      '総対潜改修値': '総対潜改修値',
      'Lv平均': 'Lv平均',
      'Lv標準偏差': 'Lv標準偏差',
      'Lv偏差値計算': 'Lv偏差値計算',
      '艦娘偏差値': '艦娘Lv偏差値',
      '全体統計データ': '全体統計データ',
      'その他のデータ': 'その他のデータ',
      '自分のデータと比較': '自分のデータと比較',
      'あなたのデータ': 'あなたのデータ',
      '総経験値平均': '総経験値平均',
      '総経験値中央値': '総経験値中央値',
      '標準偏差': '標準偏差',
      '偏差値': '偏差値',
      'コンバート艦': 'コンバート艦 どの形態が人気？',
      '所持率': '所持率',
      '総在庫数': '総在庫数',
      '平均所持数': '平均所持数',
      '最多所持数': '最多所持数',
      '集計の結果を閲覧する': '集計の結果を閲覧する',
      '自分のデータを送信する': '艦隊データを送信する',
      'データ送信': 'データ送信',
      'あなたの艦隊、装備データを統計データの集計対象として送信します。': 'データ送信すると、あなたの艦隊、装備データが統計の集計対象となります。',
      '集計は一日一回実行されます。データを送信した後すぐに反映はされませんのでご注意ください。': '集計は毎朝4時頃に実行されます。データ送信後は、一晩寝てまた確認しに来てください。',
      '送信しました': 'データの送信が完了しました。また明日見に来てください。',
      '集計データが取得できませんでした。': '集計データが取得できませんでした。',
      '一度、サイトの再読み込みをしてみてください。それでも取得できない場合は集計中かも。': '一度、サイトの再読み込みをしてみてください。それでも取得できない場合は集計中かもしれないのでまた後で試してください。',
      'Lv中央値': 'Lv中央値',
      'サーバー平均': 'サーバー平均',
      'サーバー中央値': 'サーバー中央値',
    },
    Extra: {
      '艦娘性能一覧': '艦娘性能一覧',
      '艦娘の基本ステータスの確認と比較を行えます。': '艦娘の基本ステータスの確認と比較を行えます。',
      '差分表示': '差分表示',
      '装備性能一覧': '装備性能一覧',
      '搭載可能な装備で絞り込み': '搭載可能な装備で絞り込み',
      '対空射撃回避機体一覧': '対空射撃回避機体一覧',
      '装備の基本ステータスの確認と比較を行えます。': '装備の基本ステータスの確認と比較を行えます。',
      '対潜値計算機': '対潜値計算機',
      '艦娘と装備から、指定した対潜値と必要なLvを計算します。': '艦娘と装備から、指定した対潜値と必要なLvを計算します。',
      '素対潜': '素対潜',
      '初期対潜': '初期対潜',
      '最大対潜': '最大対潜',
      '表示対潜': '表示対潜',
      '装備対潜合計': '装備対潜合計',
      '装備ボーナス合計': '装備ボーナス合計',
      '目標対潜値': '目標対潜値',
      '必要Exp': '必要exp',
      '到達不可': '到達不可',
      '参考': '参考',
      '先制対潜発動条件について': '先制対潜発動条件について',
      '敵艦生息地検索': '敵艦生息地検索',
      '指定した敵艦が登場する海域を検索します。データが更新されていない場合もあるので、あくまで参考程度に。': '指定した敵艦が登場する海域を検索します。データが更新されていない場合もあるので、あくまで参考程度に。',
      '検索する敵艦を選択': '検索する敵艦を選択',
      '艦隊詳細': '艦隊詳細',
      '戦果砲管理': '戦果砲管理',
      '戦果に関係する任務の進捗を管理する機能です。': '戦果に関係する任務の進捗を管理する機能です。',
      '未達成': '未達成',
      '達成済': '達成済',
      '達成': '達成',
      '未達成にする': '未達成にする',
      'あと': 'あと',
      'x日': '{days}日',
      '1日': '1日',
      '失効': '失効',
      '達成日': '達成日',
      'S勝利': 'S勝利',
      'A勝利': 'A勝利',
      '戦果砲残弾合計': '戦果砲残弾合計',
      'クォータリー': 'クォータリー',
      'イヤーリー': 'イヤーリー',
      '単発': '単発',
      'マンスリー': 'マンスリー',
      'ウィークリー': 'ウィークリー',
      '全て': '全て',
      'wikiで開く': 'wikiで開く',
      '改装特務空母「Gambier Bay Mk II」抜錨！': '改装特務空母「Gambier Bay Mk.II」抜錨！',
      '戦果拡張任務！「Z作戦」前段作戦': '戦果拡張任務！「Z作戦」前段作戦',
      '新編成「三川艦隊」、鉄底海峡に突入せよ！': '新編成「三川艦隊」、鉄底海峡に突入せよ！',
      '泊地周辺海域の安全確保を徹底せよ！': '泊地周辺海域の安全確保を徹底せよ！',
      '戦果拡張任務！「Z作戦」後段作戦': '戦果拡張任務！「Z作戦」後段作戦',
      '南西諸島方面「海上警備行動」発令！': '南西諸島方面「海上警備行動」発令！',
      '発令！「西方海域作戦」': '発令！「西方海域作戦」',
      '拡張「六水戦」、最前線へ！': '拡張「六水戦」、最前線へ！',
      'AL作戦': 'AL作戦',
      '機動部隊決戦': '機動部隊決戦',
      'この任務を達成状態にしますか？': 'この任務を達成状態にしますか？',
      '達成した任務は、達成済タブに表示されるようになります。': '達成した任務は、「達成済」タブに表示されるようになります。',
      '達成しました。': '達成しました。',
      '全ての任務進捗をリセットします。よろしいですか？': '全ての任務進捗をリセットします。よろしいですか？',
      'リセットしました。': 'リセットしました。',
      '敵対空おばけ': '敵対空おばけ',
      '敵艦の対空砲火ランキングです。見かけたら気を付けるか覚悟しましょう。': '敵艦の対空砲火ランキングです。見かけたら気を付けるか覚悟しましょう。',
      '順位': '順位',
      '機': '機',
      '備考': '備考',
      '対空CI発動可能': '対空CI発動可能',
      '装備シナジーチェッカー': '装備シナジーチェッカー(仮)',
      '条件': '条件',
      '累積可': '累積可',
      '累積不可': '累積不可',
      '水上電探': '水上電探',
      '対空電探': '対空電探',
      '命中電探': '命中+8以上の電探',
    },
    EType: {
      '小口径主砲': '小口径主砲',
      '中口径主砲': '中口径主砲',
      '大口径主砲': '大口径主砲',
      '副砲': '副砲',
      '魚雷': '魚雷',
      '艦上戦闘機': '艦上戦闘機',
      '艦上爆撃機': '艦上爆撃機',
      '艦上攻撃機': '艦上攻撃機',
      '艦上偵察機': '艦上偵察機',
      '水上偵察機': '水上偵察機',
      '水上爆撃機': '水上爆撃機',
      '小型電探': '小型電探',
      '大型電探': '大型電探',
      'ソナー': 'ソナー',
      '爆雷': '爆雷',
      '爆雷投射機': '爆雷投射機',
      '追加装甲': '追加装甲',
      '機関部強化': '機関部強化',
      '対空強化弾': '対空強化弾',
      '対艦強化弾': '対艦強化弾',
      'VT信管': 'VT信管',
      '対空機銃': '対空機銃',
      '特殊潜航艇': '特殊潜航艇',
      '応急修理要員': '応急修理要員',
      '上陸用舟艇': '上陸用舟艇',
      '回転翼機': '回転翼機',
      '対潜哨戒機': '対潜哨戒機',
      '追加装甲(中型)': '追加装甲(中型)',
      '追加装甲(大型)': '追加装甲(大型)',
      '探照灯': '探照灯',
      '簡易輸送部材': '簡易輸送部材',
      '艦艇修理施設': '艦艇修理施設',
      '潜水艦魚雷': '潜水艦魚雷',
      '照明弾': '照明弾',
      '司令部施設': '司令部施設',
      '航空要員': '航空要員',
      '高射装置': '高射装置',
      '対地装備': '対地装備',
      '大口径主砲(II)': '大口径主砲(II)',
      '水上艦要員': '水上艦要員',
      '大型ソナー': '大型ソナー',
      '大型飛行艇': '大型飛行艇',
      '大型探照灯': '大型探照灯',
      '戦闘糧食': '戦闘糧食',
      '補給物資': '補給物資',
      '水上戦闘機': '水上戦闘機',
      '特型内火艇': '特型内火艇',
      '陸上攻撃機': '陸上攻撃機',
      '局地/陸軍戦闘機': '局地/陸軍戦闘機',
      '陸上偵察機': '陸上偵察機',
      '輸送機材': '輸送機材',
      '潜水艦装備': '潜水艦装備',
      '大型陸上機': '大型陸上機',
      '噴式戦闘機': '噴式戦闘機',
      '噴式戦闘爆撃機': '噴式戦闘爆撃機',
      '噴式艦上戦闘機': '噴式艦上戦闘機',
      '噴式攻撃機': '噴式攻撃機',
      '噴式偵察機': '噴式偵察機',
      '大型電探(II)': '大型電探(II)',
      '艦上偵察機(II)': '艦上偵察機(II)',
      '副砲(II)': '副砲(II)',
      '艦戦': '艦戦',
      '艦爆': '艦爆',
      '艦攻': '艦攻',
      '艦偵': '艦偵',
      '噴式機': '噴式機',
      '水偵': '水偵',
      '水爆': '水爆',
      '水戦': '水戦',
      '電探': '電探',
      '対潜装備': '対潜装備',
      '機銃': '機銃',
      '陸攻': '陸攻',
      '局戦': '局戦',
      '陸偵': '陸偵',
      '陸戦部隊': '陸戦部隊',
      '艦載発煙装置': '艦載発煙装置',
      'その他': 'その他',
    },
    SType: {
      '海防': '海防',
      '駆逐': '駆逐',
      '軽巡': '軽巡',
      '雷巡': '雷巡',
      '重巡': '重巡',
      '航巡': '航巡',
      '軽母': '軽母',
      '高戦': '高戦',
      '戦巡': '戦巡',
      '戦艦': '戦艦',
      '航戦': '航戦',
      '空母': '空母',
      '超戦': '超戦',
      '潜水': '潜水',
      '航潜': '航潜',
      '輸送': '輸送',
      '水母': '水母',
      '揚陸': '揚陸',
      '装母': '装母',
      '装空': '装空',
      '工作': '工作',
      '潜母': '潜母',
      '練巡': '練巡',
      '補給': '補給',
      '護母': '護母',
      'その他': 'その他',
      '正規空母': '正規空母',
      '軽空母': '軽空母',
      '戦艦級': '戦艦級',
      '重巡級': '重巡級',
      '軽巡級': '軽巡級',
      '駆逐艦': '駆逐艦',
      '海防艦': '海防艦',
      '潜水艦': '潜水艦',
      '補助艦艇': '補助艦艇',
      '合計': '合計',
      '高速戦艦': '高速戦艦',
      '航空戦艦': '航空戦艦',
      '潜水空母': '潜水空母',
      '揚陸艦': '揚陸艦',
      '装甲空母': '装甲空母',
      '工作艦': '工作艦',
      '潜水母艦': '潜水母艦',
      '巡洋艦系': '巡洋艦系',
      '軽空母と空母': '軽空母+空母',
      '護衛空母': '護衛空母',
      '駆逐艦または海防艦': '駆逐艦または海防艦',
      '軽巡または練巡': '軽巡または練巡',
    },
  },
};
